<template>
    <div>
        <header>
            <div class="row">
                <div class="col-md-3 col-xs-12"><h1 class="logo"><a href="http://www.helloweba.net" title="返回helloweba首页">helloweba</a></h1></div>
                <div class="col-md-9 text-right">{{topadver}}</div>
            </div>
        </header>
    </div>
</template>

<script>
import {topAdver} from '../assets/js/ad.js';

export default {
    data () {
        return {
            topadver: ''
        }
    },
    mounted() {
        console.log('xxx');
        //this.topadver = topAdver;
    },
    methods: {
        //
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Header.vue